import { useMutation, useQueryClient } from "@tanstack/react-query";
import apiClient from "@/modules/request.module.v2";
import {
  addErrorNotification,
  addInfoNotification,
} from "@/components/framework/notify";

export default (companyId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["createUserComm", companyId],
    mutationFn: (payload) => {
      return apiClient.post(`notifications/user-comms`, payload, {
        headers: { "x-company-id": companyId },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries("userComms");

      addInfoNotification({
        tid: "success",
      });
    },
    onError: () => {
      addErrorNotification({ tid: "generic.unknown_error" });
    },
  });
};
